import { render, staticRenderFns } from "./informAdd.vue?vue&type=template&id=6911d022&scoped=true&"
import script from "./informAdd.vue?vue&type=script&lang=js&"
export * from "./informAdd.vue?vue&type=script&lang=js&"
import style0 from "./informAdd.vue?vue&type=style&index=0&id=6911d022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911d022",
  null
  
)

export default component.exports